import React from "react";
import { Link } from "react-router-dom";
import "../components css/navbar.css"
import LedLight from "./ledLight";
import { useTranslation } from "react-i18next";
 function Navbar(){

    let { t, i18n} = useTranslation();
    function activeHome(){
        let allItems = document.querySelectorAll("header li");
        let home = document.getElementById('fChild')
        allItems.forEach(element => {
            element.className='';
        });
        home.className = 'active';
    }
    function activeStories(){
        let allItems = document.querySelectorAll("header li");
        let home = document.getElementById('sChild')
        allItems.forEach(element => {
            element.className='';
        });
        home.className = 'active';
    }

        return(
            <>
                <LedLight/>
                <header className="sticky-top">
                        <div className = "logog">
                            <Link style={{color:'white'}} onClick={()=>{activeHome()}} to='/'><h2>{t('NavbarTitle')}</h2></Link>
                        </div>
                        <div className = "list">
                        <ul style={{alignItems:"center"}}>
                                <Link to="/" ><li id="fChild" className="active" onClick={()=>{activeHome()}}>{t("NavbarM1")}</li></Link>       
                                <Link to="stories" ><li onClick={()=>{activeStories()}} id="sChild">{t('NavbarM2')}</li></Link>  
                                {
                                    i18n.language==="ar"?<button type="button" className="btn btn-white storiesButCh" style={{marginTop:"10px" ,zIndex:"10000"}} onClick={()=>{i18n.changeLanguage('en') ; console.log(i18n.dir())}}>En</button>:
                                    <button type="button" className="btn btn-white storiesButCh" style={{marginTop:"10px" , zIndex:"10000"}} onClick={()=>{i18n.changeLanguage('ar') ;console.log(i18n.dir())}}>Ar</button>
                                }                
                        </ul>
                        </div>
            </header>

            </>
        )
}
export default Navbar